import React from 'react';
import { useCountdown, CountdownDisplay } from './Countdown';
import TimerIcon from '@mui/icons-material/Timer';
export function UrgencyBlock() {
  const timeLeft = useCountdown();
  return <section className="py-6 px-4 bg-red-600 text-white text-center" data-id="element-290">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-3" data-id="element-291">
        <div className="flex items-center gap-2 text-base sm:text-lg font-bold uppercase tracking-wider" data-id="element-292">
          <TimerIcon fontSize="small" data-id="element-293" /> ESTA OFERTA CIERRA EN:
        </div>

        <div className="scale-110 sm:scale-125 transform origin-center my-1" data-id="element-294">
          <CountdownDisplay {...timeLeft} data-id="element-295" />
        </div>

        <div className="bg-red-700/50 px-4 py-2 rounded-xl border border-red-500/50" data-id="element-296">
          <p className="font-bold text-sm sm:text-base mb-0.5" data-id="element-297">
            ⚠️ Después aumenta de precio.
          </p>
          <p className="text-red-100 text-sm" data-id="element-298">
            🔴 Cada vez más personas están entrando al nicho pet artesanal.
          </p>
        </div>
      </div>
    </section>;
}